export default __webpack_public_path__ + "static/media/prev-antenna-1.c9fcc957.png";